export type VolumePage = {
  src: string
  page: number
  label: string
  line: string
}

/** Volume 5 · Presence & Nature — real pages, upload order = slide order. */
export const volumeFivePages: VolumePage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/2i4hc4N3QpXK7Ya9RoaeAH/01-portada.jpg',
    page: 1,
    label: 'Volume 5 · Presence & Nature',
    line: '14 ready-to-run plans for slow, seasonal and outdoor classes.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/hQtErX7Kus49BpPsPRUvPT/02-plan-vp57-el-arco.jpg',
    page: 7,
    label: 'The Arc page',
    line: 'intention, phases, minutes, formation and contact level for the whole class.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/bPMQdgFtgG6GbVzd9JdLWP/03-stillness-gradient.jpg',
    page: 6,
    label: 'The Stillness Gradient',
    line: 'bring any group into quiet and back, step by step.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/1vqpVXMdRXGZb1fq3pYnsC/04-four-element-wheel.jpg',
    page: 17,
    label: 'The Four-Element Wheel',
    line: 'earth, water, air and fire as movement qualities, with tempo ranges.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/qMXntXgSPcKoqY2pJ9C6XM/05-vp66-winter-light.jpg',
    page: 32,
    label: 'Winter Light',
    line: 'a warm class that gathers the group around one lantern.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/7sw56dyjHBepC6HuKJ4dwM/06-vp68-barefoot-on-the-grass.jpg',
    page: 37,
    label: 'Barefoot on the Grass',
    line: 'a full park class for open lawns.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/q1fq4wYHBydWSyqFFxFQAN/07-vp69-beach-circle.jpg',
    page: 39,
    label: 'Beach Circle',
    line: 'sand, wind and waves as your soundtrack.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/oZgmWxW32zovEWbfByGfYb/08-vp70-among-the-trees.jpg',
    page: 41,
    label: 'Among the Trees',
    line: 'a quiet forest-edge class, boundaries included.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/vVFyNkFwZBLECZuPMJ48XE/09-seasonal-theme-calendar.jpg',
    page: 45,
    label: 'Seasonal Theme Calendar',
    line: 'one theme per month, north and south hemisphere.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/4D7Txxf2VXRsLg9QJD8PAa/10-field-card.jpg',
    page: 50,
    label: 'Field Card',
    line: 'the whole volume on one page to take to class.',
  },
]
